export const CHAT_FAQS = [
  {
    question: 'What is Credit99?',
    answer:
      'Credit99 is a digital lending platform for salaried professionals who need quick access to Ultra Short Term Loans. The service is powered by Marathon Finlease Private Limited, an RBI-registered NBFC, with transparent terms, paperless KYC, and fast disbursal.',
    keywords: ['credit99', 'credit 99', 'about', 'company', 'kya hai', 'platform', 'nbfc', 'marathon'],
  },
  {
    question: 'What type of loans does Credit99 offer?',
    answer:
      'We offer Ultra Short Term Loans for everyday needs — medical emergencies, rent, travel, or urgent expenses. Tenure typically ranges from 7 to 365 days, depending on your profile and eligibility.',
    keywords: ['loan type', 'ultra short', 'short term', 'tenure', 'days', 'months', 'kis type', 'kaise loan'],
  },
  {
    question: 'How do I apply for a loan?',
    answer:
      'Click Apply Now on our website, fill in your basic details and PAN, complete digital verification, and submit the form. Our team reviews your application and shares the decision quickly — often within minutes during working hours.',
    keywords: ['apply', 'application', 'form', 'kaise apply', 'apply kaise', 'start', 'begin'],
    link: { label: 'Apply Now', path: '/apply-now' },
  },
  {
    question: 'How much loan can I get?',
    answer:
      'Credit99 does not sanction loans exceeding ₹1,00,000. The approved amount depends on your monthly income, employment stability, existing obligations, and credit assessment.',
    keywords: ['amount', 'kitna', 'maximum', '1 lakh', '100000', 'limit', 'loan kitna'],
  },
  {
    question: 'How long does approval and disbursal take?',
    answer:
      'Once your documents and verification are complete, approval can happen within minutes. After approval, funds are transferred directly to your registered bank account — usually on the same working day.',
    keywords: ['approval', 'disbursal', 'time', 'kitne din', 'fast', 'minutes', 'kab milega'],
  },
  {
    question: 'Who is eligible to apply?',
    answer:
      'You must be a salaried Indian resident aged 21–58 years, employed for at least 6 months with stable monthly income, and hold valid PAN and Aadhaar. Final eligibility is confirmed after our assessment.',
    keywords: ['eligible', 'eligibility', 'age', 'salaried', 'criteria', 'kaun apply', 'yogya'],
    link: { label: 'View eligibility', path: '/#eligibility-criteria' },
  },
  {
    question: 'Which documents are required?',
    answer:
      'Typically you need PAN card, Aadhaar for KYC, recent salary slips (last 3 months), bank statements (last 6 months), and a passport-size photograph. Additional documents may be requested based on your profile.',
    keywords: ['document', 'documents', 'kyc', 'pan', 'aadhaar', 'salary slip', 'papers', 'kagaz'],
  },
  {
    question: 'Can I apply with a low credit score?',
    answer:
      'Yes, you can still apply. Approval is based on your overall profile — income, job stability, repayment history, and existing EMIs — not just your credit score alone.',
    keywords: ['cibil', 'credit score', 'low score', 'bad credit', 'cibil score'],
  },
  {
    question: 'How do I repay my loan?',
    answer:
      'Visit the Repay Loan page, enter your registered mobile number or PAN to view your outstanding amount, and pay via bank transfer or UPI using the details provided.',
    keywords: ['repay', 'repayment', 'pay', 'emi', 'bharna', 'payment', 'due'],
    link: { label: 'Repay Loan', path: '/repay-loan' },
  },
  {
    question: 'Can I repay before the due date?',
    answer:
      'Yes, early repayment is allowed. Any applicable prepayment terms will be mentioned in your loan agreement. Contact support before making an early settlement if you need guidance.',
    keywords: ['prepay', 'early', 'before due', 'foreclose', 'jaldi repay'],
  },
  {
    question: 'What happens if I miss a repayment?',
    answer:
      'Missing a due date may attract late payment charges and can affect your credit score. Set up reminders or NACH auto-debit. If you anticipate a delay, reach out to us early.',
    keywords: ['miss', 'late', 'default', 'penalty', 'delay', 'missed emi'],
  },
  {
    question: 'Is my personal data safe?',
    answer:
      'Yes. Credit99 uses encrypted connections and secure servers to protect your data. We follow applicable privacy regulations and never share your information with unauthorized third parties.',
    keywords: ['safe', 'security', 'data', 'privacy', 'secure', 'surakshit'],
    link: { label: 'Privacy Policy', path: '/privacy-policy' },
  },
  {
    question: 'How can I track my application status?',
    answer:
      'After submitting your application, you receive updates via SMS and email. You can also check status online or contact support with your registered mobile number or PAN.',
    keywords: ['status', 'track', 'check application', 'application status', 'kahan hai'],
    link: { label: 'Check status', path: '/check' },
  },
  {
    question: 'How do I contact customer support?',
    answer:
      'Reach us Monday to Saturday, 10 AM – 7 PM via phone at +91-8796447298, email at info@credit99.com, or the Contact Us page. Our team helps with applications, repayments, and general queries.',
    keywords: ['contact', 'support', 'help', 'phone', 'call', 'email', 'customer care'],
    link: { label: 'Contact Us', path: '/contact-us' },
  },
];

export const CHAT_QUICK_ACTIONS = [
  { id: 'apply', label: 'Apply', emoji: '📝' },
  { id: 'eligibility', label: 'Eligible?', emoji: '✅' },
  { id: 'documents', label: 'Documents', emoji: '📄' },
  { id: 'amount', label: 'Amount', emoji: '💰' },
  { id: 'repay', label: 'Repay', emoji: '🔄' },
  { id: 'status', label: 'Status', emoji: '📍' },
];

export const CHAT_GREETINGS = [
  'namaste',
  'namaskar',
  'hello',
  'hi',
  'hey',
  'good morning',
  'good afternoon',
  'good evening',
  'hii',
  'hola',
];

export const CHAT_THANKS = ['thank', 'thanks', 'dhanyavad', 'shukriya', 'thankyou', 'thx'];

export { SUPPORT_PHONE, SUPPORT_PHONE_TEL, WHATSAPP_NUMBER } from '../constants/contact';
export const SUPPORT_EMAIL = 'info@credit99.com';
